import request from "../../../helpers/request";
import { getUser } from "../../../helpers/user";
import { ELevelUser } from "../types";

export const getDivisoes = async () => {
  const {
    usuario: { nivel, id },
  } = getUser();
  const url =
    nivel === ELevelUser.GERENCIA_MANUTENCAO_REGIONAIS
      ? `/Divisao/GetDivisoesIdGerente?idGerente=${id}`
      : "/Divisao";

  try {
    const response = await request({ url });

    console.log("response", response);

    return response;
  } catch (err) {
    throw err;
  }
};
